import { t } from 'ember-intl';
import QuestionsLoanTypesCard from 'tio-employee/components/questions/loan-types-card';
import QuestionsNumberedStep from 'tio-employee/components/questions/numbered-step';
import { VStack } from 'tio-ui/components/layout';
import LandingInfoCard from 'tio-employee/components/landing/info-card';
import {
  PhCurrencyDollar,
  PhPercent,
  PhWarning,
  PhCaretDoubleRight,
  PhThumbsUp,
  PhListChecks,
} from 'ember-phosphor-icons';

<template>
  <VStack class="gap-6">
    <LandingInfoCard
      @icon={{PhThumbsUp}}
      @iconColor="green"
      @title={{t "questions_you_have.types_of_student_loans.pros.pros_private"}}
    >
      <div class="grid grid-cols-1 gap-4">
        <QuestionsLoanTypesCard
          @icon={{PhCurrencyDollar}}
          @label={{t "questions_you_have.types_of_student_loans.pros.pros_private_text"}}
        />
      </div>
    </LandingInfoCard>

    <LandingInfoCard
      @icon={{PhWarning}}
      @iconColor="amber"
      @title={{t "questions_you_have.types_of_student_loans.cons.cons_private"}}
    >
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <QuestionsLoanTypesCard
          @icon={{PhPercent}}
          @label={{t
            "questions_you_have.types_of_student_loans.cons.generally_higher_interest_rate"
          }}
        />
        <QuestionsLoanTypesCard
          @icon={{PhWarning}}
          @label={{t
            "questions_you_have.types_of_student_loans.cons.dont_have_repayment_plan_flexibility"
          }}
        />
        <QuestionsLoanTypesCard
          @icon={{PhCaretDoubleRight}}
          @label={{t "questions_you_have.types_of_student_loans.cons.very_few_options"}}
        />
      </div>
    </LandingInfoCard>

    <LandingInfoCard
      @icon={{PhListChecks}}
      @iconColor="violet"
      @title={{t "questions_you_have.how_to_apply.default"}}
    >
      <VStack class="gap-6">
        <QuestionsNumberedStep
          @number="number_one"
          @title="questions_you_have.how_to_apply.decide_if_cosigner.default"
          @points={{array
            "questions_you_have.how_to_apply.decide_if_cosigner.point_1"
            "questions_you_have.how_to_apply.decide_if_cosigner.point_2"
          }}
        />
        <QuestionsNumberedStep
          @number="number_two"
          @title="questions_you_have.how_to_apply.check_application_requirements.default"
          @intro="questions_you_have.how_to_apply.check_requirements_private.header"
          @points={{array
            "questions_you_have.how_to_apply.check_requirements_private.point_1"
            "questions_you_have.how_to_apply.check_requirements_private.point_2"
            "questions_you_have.how_to_apply.check_requirements_private.point_3"
            "questions_you_have.how_to_apply.check_requirements_private.point_4"
            "questions_you_have.how_to_apply.check_requirements_private.point_5"
          }}
        />
      </VStack>
    </LandingInfoCard>
  </VStack>
</template>
